import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pb-6" }
const _hoisted_2 = { class: "pb-6" }
const _hoisted_3 = { class: "v-col-6 pr-0" }
const _hoisted_4 = { class: "d-flex align-center justify-end ga-2" }
const _hoisted_5 = ["disabled", "readonly"]
const _hoisted_6 = { style: {"width":"fit-content"} }
const _hoisted_7 = { class: "d-flex align-center ga-4 py-2" }
const _hoisted_8 = { class: "font-size-12-600 font-black" }
const _hoisted_9 = {
  key: 0,
  class: "my-3"
}

import {ref, watch} from 'vue';
import TextArea from "@/components/custom/TextArea.vue";
import SelectDropdown from "@/components/custom/SelectDropdown.vue";
import FlexContainer from "@/components/custom/FlexContainer.vue";
import ErrorMessages from "@/components/custom/ErrorMessages.vue";
import {timeframeUnit} from "../Helpers.ts";
import {useRoute} from "vue-router";
import RatingSlider from "@/components/custom/RatingSlider.vue";
import RotatingArrow from "@/components/custom/RotatingArrow.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthGoalForm',
  props: {
  modelValue: {
    type: Object,
  },

  variant: {
    type: String,
  },

  disabledSelect: {
    type: Boolean,
    default: false,
  },

  readonlySelect: {
    type: Boolean,
    default: false,
  },

  errors: {
    type: Object,
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const route = useRoute();

const emit = __emit

const props = __props

const setForm = ref({...props.modelValue});
const rotateArrowForRating = ref(false);

watch(() => props.modelValue, (val) => {
  setForm.value = val
})

watch(setForm, (newValue) => {
  if (newValue.severity_rating > 0) {
    rotateArrowForRating.value = true;
  }

  emit('update:modelValue', newValue);
}, {deep: true});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text_field, {
      placeholder: "Name",
      density: "compact",
      class: "pt-3 pb-5",
      width: "100%",
      variant: "solo",
      elevation: "0",
      "hide-details": "",
      modelValue: setForm.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setForm.value.name) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "name"
    }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "font-size-12-400 font-grey pb-2" }, "Description", -1)),
      _createVNode(TextArea, {
        modelValue: setForm.value.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((setForm.value.description) = $event)),
        rows: "3"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "description"
    }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "font-size-12-400 font-grey pb-2" }, "Why Does This Matter?", -1)),
      _createVNode(TextArea, {
        modelValue: setForm.value.reason,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((setForm.value.reason) = $event)),
        rows: "3"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "reason"
    }, null, 8, ["errors"]),
    _createVNode(FlexContainer, { title: "Timeframe" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "styled-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((setForm.value.timeframe_value) = $event)),
              type: "number",
              min: "1",
              disabled: __props.disabledSelect,
              readonly: __props.readonlySelect,
              oninput: "this.value = this.value.replace(/[^0-9]/g, '')"
            }, null, 8, _hoisted_5), [
              [_vModelText, setForm.value.timeframe_value]
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(SelectDropdown, {
                modelValue: setForm.value.timeframe_unit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((setForm.value.timeframe_unit) = $event)),
                items: _unref(timeframeUnit),
                variant: __props.variant,
                disabled: __props.disabledSelect,
                readonly: __props.readonlySelect
              }, null, 8, ["modelValue", "items", "variant", "disabled", "readonly"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "timeframe_value"
    }, null, 8, ["errors"]),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "timeframe_unit"
    }, null, 8, ["errors"]),
    _createVNode(_component_v_divider),
    _createVNode(FlexContainer, {
      title: "Severity rating",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (rotateArrowForRating.value = !rotateArrowForRating.value))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(setForm.value.severity_rating) + "/10", 1),
          _createVNode(RotatingArrow, { "rotate-arrow": rotateArrowForRating.value }, null, 8, ["rotate-arrow"])
        ])
      ]),
      _: 1
    }),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "severity_rating"
    }, null, 8, ["errors"]),
    _createVNode(_component_v_divider),
    (rotateArrowForRating.value === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(RatingSlider, {
            modelValue: setForm.value.severity_rating,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((setForm.value.severity_rating) = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})